/* eslint @typescript-eslint/no-explicit-any: 0 */
import React, { forwardRef } from 'react';
import Styled from './Styled';
const Anchor = forwardRef(({ bold, underline, large, primary, ...props }, ref) => (React.createElement(Styled.Wrapper, Object.assign({ ref: ref, "$bold": bold, "$underline": underline, "$large": large, "$primary": primary }, props))));
export default Anchor;
